import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Logs management stack layout
 */
export default function LogsLayout() {
  const router = useRouter();
  const navigation = useNavigation();
  const colors = useThemeColors();

  /**
   * Handle back navigation safely
   * If there's no screen to go back to, navigate to tabs
   */
  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: "#DC2626",
        headerTitleStyle: { color: colors.text },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color="#DC2626" />
          </Pressable>
        ),
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Activiteiten Log" }}
      />
    </Stack>
  );
}
